<template>
  <div id="app">
    <component :is="layout"></component>
    <div id="countdownBtn" style="display: none;"></div>
    <div class="loading-tourists-mask" v-if="loading">
      <loading :box-size="14" :round-size="3" :color="'#306fff'"></loading>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Common from '@/layouts/Common'
import Noop from '@/layouts/Noop'
import judge from '@/router/judge'
import main from '@/router/main'
import { get, post } from '@/utils/ajax'
import Loading from '@/components/Loading'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import qs from 'qs'

export default {
  components: {
    Loading
  },
  computed: {
    ...mapState(['user', 'site_msg']),
    layout () {
      switch (this.$route.meta.layout) {
        case 'Noop':
          return Noop
        default:
          return Common
      }
    }
  },
  data () {
    return {
      loading: true,
      userId: 0
    }
  },
  mounted () {
    this.init()
    this.setBrowserFinger()
  },
  methods: {
    // 判断是否走站点逻辑（现在router还是空）
    async init () {
      const pathName = window.location.pathname.split('/')[1]

      if (pathName === 'proctoring-mini' || pathName === 'mental-auth') {
        this.loading = false
        return
      }

      // 判断是否是深空c++比赛
      const isCpp = new URLSearchParams(window.location.search).get('isCpp') === '1'
      if (isCpp) {
        sessionStorage.setItem('isCpp', '1')
      } else {
        sessionStorage.removeItem('isCpp')
      }
      if (!pathName) {
        this.$message.info('区域站点没有找到')
        return
      }
      await this.fetchUserInfo()
      if (['judge'].includes(pathName)) {
        this.addJudgeRoutes()
      } else {
        this.addMainRoutes()
      }
    },
    async fetchUserInfo () {
      try {
        const userInfo = await this.$auth('get_profile')
        this.userId = userInfo.id
        this.$store.commit('HAS_TOKEN', true)
        this.$store.commit('SET_USER', userInfo)
        localStorage.setItem('user_id', this.userId)
      } catch (e) { }
    },
    // 加入阅卷路由
    addJudgeRoutes () {
      this.$router.addRoutes(judge)
      this.loading = false
    },
    // 加入主路由
    async addMainRoutes () {
      try {
        await this.getSiteMsg()
        await this.toKpcbLogin()
        this.setSiteTheme()
        await this.goAutomatic()
        const pathName = window.location.pathname.split('/')[1]
        const path = sessionStorage.getItem('path')

        const routes = main.map(el => {
          if (el.redirect) {
            el.redirect = `/${pathName}${el.redirect}`
          }
          el.path = `/${pathName}${el.path}`
          return el
        })
        this.$router.addRoutes(routes)

        // 切换站点，移除本地缓存
        if (path !== pathName) {
          sessionStorage.setItem('path', pathName)
          if (path) {
            localStorage.removeItem('examId')
            localStorage.removeItem('examineeId')
            localStorage.removeItem('needIdentity')
            localStorage.removeItem('needNotice')
          }
        }
      } catch (e) { }
    },
    // 获取站点信息设置是否是游客模式，然后进行路由的跳转
    async getSiteMsg () {
      await this.$store.dispatch('getInitSiteMsg', this.userId)
      this.loading = false
    },
    // 对接信息素养大赛登录
    async toKpcbLogin () {
      // 先进行信息判断，对接信息素养大赛，免登录，只可能为普通测评
      if (this.site_msg.loginEnabled) {
        // 用于签名的key
        const kpcbKeys = ['timestamp', 'userId', 'realName', 'examCode']
        // 是否为信息素养大赛的链接，用于签名的参数都需要校验
        const query = window.location.search.split('?')[1]
        const isKpcb = query && kpcbKeys.every(k => query.indexOf(k) > -1)
        if (isKpcb) {
          try {
            const parsedQuery = qs.parse(decodeURIComponent(query))
            // 获取协议列表
            const list = await get(`${window.CONFIG.api_backend}/tiger/v3/web/accounts/agreements`)
            // 无感颁发登录态
            const params = {
              agreementIds: list.map(item => item.id) || [],
              pid: 'At8CiphS',
              ...parsedQuery
            }
            const res = await post(`${window.CONFIG.api_backend}/tiger/v3/web/accounts/oauth/information-literacy`, params)
            if (res.auth && res.auth.token) {
              this.$store.commit('HAS_TOKEN', true)
              const result = await post(`/home/edu/examinees/saveCieExaminees`, { ...parsedQuery })
              if (result.address) {
                // 跳转列表页
                window.location.href = `${result.address}/list`
              } else {
                window.location.replace('error')
                throw new Error('保存考生信息失败')
              }
            }
          } catch (error) {
            window.location.replace('error')
          }
        }
      }
    },
    // 设置站点主题
    setSiteTheme () {
      const res = this.site_msg
      // 新加：是否隐藏个人信息/是否排过考/是否按照指定考试id带参
      const themeInfo = {
        ...res,
        themeColor: res.text_theme + ';',
        lightThemeColor: this.hexToRgba(res.text_theme, 0.15) + ';',
        themeSubColor: this.hexToRgba(res.text_theme, 0.05) + ';',
        buttonShadow: ` 0 6px 12px 0px ${this.hexToRgba(res.btn_theme.split(', ')[1], 0.3)};`,
        buttonBackground: `linear-gradient(135deg,${this.hexToRgba(res.btn_theme.split(', ')[0], 1)} 0%, ${this.hexToRgba(res.btn_theme.split(', ')[1], 1)} 100%);`
      }
      this.$store.commit('SETSTATE', { key: 'theme', value: themeInfo })
      document.title = themeInfo.title
    },
    // 自动排考
    async goAutomatic () {
      if (!this.$store.state.hasToken) return
      // 有选择排考且还没排考
      if (this.site_msg.is_automatic && !this.site_msg.arrange) {
        const url = `${CONFIG.edu_test}/${location.href.split('/')[3]}`
        try {
          const automatic = await post('/home/sites/auto/arrange', { address: url, name: this.user.fullname || localStorage.currentAccount || this.user.nickname, userId: this.user.id })
          console.log(automatic)
        } catch (e) { }
      }
    },
    hexToRgba (hex, opacity) {
      return 'rgba(' + parseInt('0x' + hex.slice(1, 3)) + ',' + parseInt('0x' + hex.slice(3, 5)) + ',' + parseInt('0x' + hex.slice(5, 7)) + ',' + opacity + ')'
    },
    // 生成浏览器指纹
    async setBrowserFinger () {
      const fp = await FingerprintJS.load({ monitoring: false })
      const result = await fp.get()
      const visitorId = result.visitorId
      this.$store.commit('SETSTATE', { key: 'browserFinger', value: visitorId })
    }
  }
}
</script>

<style lang="scss" src="@/assets/styles/index.scss"></style>
<style lang="scss">
.loading-tourists-mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 10;
  background-color: #fafafa;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
